import React, {useEffect, useRef, useState} from 'react';
import { StyledSustainability } from '@/components/common/ygen/sections/sustain/sustain.style';
import {Container} from "react-bootstrap";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination} from 'swiper/modules';
import SustainabilitySingle from '@/components/common/ui/single-item/SustainabilitySingle';
import Prev from '@/components/common/ui/buttons/Prev';
import Next from '@/components/common/ui/buttons/Next';
import useContainerOffset from '@/components/hooks/useContainerOffset';
import useAnimatedText from '@/components/animations/useAnimatedText';

const Sustainability = ({data,id,no_slider}) => {
    const nextRef = useRef()
    const prevRef = useRef()
    const [current, setCurrent] = useState('1')
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const offset = useContainerOffset('.container')

    const handleSliderCurrent = () => {
        setTimeout(() => {
            if (document.querySelector('.sustain .swiper-pagination-current')) {
                setCurrent(document.querySelector('.sustain .swiper-pagination-current').innerHTML)
            }
        }, 200)
    }
    useAnimatedText([prevRef, nextRef]);
    return (
        <StyledSustainability id={`${id ? id : "Sustainability"}`} offset={offset} data-scroll-section className={`sustain ${no_slider ? 'slider_no' : ''}`}>
            <div className="header">
                <div className={'sustain__top'}>
                    {
                        data?.section_data?.subtitle &&
                        <h6>{data?.section_data?.subtitle}</h6>

                    }
                </div>
                <ul className={'navigation_item'}>
                    <li className={'prev_swipper'} ref={prevRef}>
                        <Prev />
                    </li>
                    <li className={'next_swipper'} ref={nextRef}>
                        <Next />
                    </li>
                </ul>
            </div>

            <Container fluid className={`sustain`}>


                {

                    data?.posts?.list &&
                    data?.posts?.list?.length > 0 &&
                    <Swiper
                        Swiper modules={[Autoplay, Pagination, Navigation]}
                        allowTouchMove={true}
                        autoHeight={true}
                        slidesPerView={1}
                        speed={1000}
                        pagination={{
                            // el: '.swiper-pagination',
                            type: "fraction",
                        }}
                        navigation={{
                            prevEl: prevRef.current,
                            nextEl: nextRef.current,
                        }}
                        onBeforeInit={(swiper) => {
                            swiper.params.navigation.prevEl = prevRef.current;
                            swiper.params.navigation.nextEl = nextRef.current;
                        }}
                        shouldSwiperUpdate={(prev, next) => {
                            if (prev.activeIndex === next.slides.length - 1) {
                                setButtonDisabled(true);
                            } else {
                                setButtonDisabled(false);
                            }
                        }}
                        loop = {false}
                        onSlideChange={(s) => handleSliderCurrent()}
                    >



                        {
                            data?.posts?.list &&
                            data?.posts?.list?.length > 0 &&
                            data?.posts?.list?.map((e, index) => {
                                return(
                                    <SwiperSlide key={index}>
                                        <SustainabilitySingle subtitle={e?.data?.subtitle} des={e?.data?.description} images={e?.images?.[0]?.full_path} />
                                    </SwiperSlide>

                                )
                            })

                        }

                    </Swiper>

                }

            </Container>
        </StyledSustainability>
    );
};


export default React.memo(Sustainability);

